import { Box } from "@mui/material";
import { motion } from "motion/react";
import Image from "mui-image";
import Unknown from "Assets/Images/ThirdParty/unknown.png";

interface ICampaignCellIconProps {
  size?: number;
  imageUrl: string;

  position?: "left" | "center" | "right";
  rounded?: boolean;
}

function CampaignCellIcon({
  size = 20,
  imageUrl,
  position = "left",
  rounded = false,
}: ICampaignCellIconProps) {
  return (
    <Box
      sx={{ width: size }}
      component={motion.div}
      initial={{
        opacity: 0,
        scale: 0,
      }}
      animate={{
        opacity: 1,
        scale: 1,
      }}
    >
      <Image
        height={size}
        width={size}
        src={imageUrl || Unknown}
        duration={50}
        fit={"contain"}
        objectPosition={position}
        sx={{
          objectPosition: position,
          borderRadius: rounded ? "50%" : "0px",
        }}
      />
    </Box>
  );
}

export default CampaignCellIcon;
